import axios from '@/plugins/axios';

export const getEventTypes = async () => {
  const { data } = await axios.get('/schedule/events/types');

  return data?.data;
};

export const getUserEvents = async (userId, { from, to, executed }) => {
  const { data } = await axios.get(`/schedule/users/${userId}/events`, {
    params: {
      from,
      to,
      ...(executed !== undefined && { executed: Number(executed) }),
    },
  });

  return data?.data;
};

export const getUsersEvents = async (userIds, { from, to, executed }) => {
  const { data } = await axios.get('/schedule/events', {
    params: {
      users: userIds,
      from,
      to,
      ...(executed !== undefined && { executed: Number(executed) }),
    },
  });

  return data?.data;
};

export const createUserEvent = async (userId, event) => {
  const { data } = await axios.post(`/schedule/users/${userId}/events`, {
    ...event,
  });

  return data?.data;
};

export const updateUserEvent = async (eventId, event) => {
  const { data } = await axios.put(`/schedule/events/${eventId}`, {
    ...event,
  });

  return data?.data;
};

export const createEventExecution = async (eventId, execution) => {
  const { data } = await axios.post(`/schedule/events/${eventId}/execution`, {
    ...execution,
  });

  return {
    event: data?.data,
    message: data?.message,
  };
};

export const updateEventExecution = async (eventId, execution) => {
  const { data } = await axios.put(`/schedule/events/${eventId}/execution`, {
    ...execution,
  });

  return data?.data;
};

export const createEventComment = async (eventId, comment) => {
  const formData = new FormData();

  formData.append('creatorId', comment.creatorId);
  formData.append('comment', comment.comment);
  (comment.images ?? []).forEach((file) => {
    formData.append('images[]', file);
  });

  const { data } = await axios.post(
    `/schedule/events/${eventId}/comments`,
    formData
  );

  return data?.data;
};

export const updateEventComment = async (eventId, commentId, text) => {
  const { data } = await axios.put(
    `/schedule/events/${eventId}/comments/${commentId}`,
    { comment: text }
  );

  return data?.data;
};

export const deleteEventComment = async (eventId, commentId) => {
  await axios.delete(`/schedule/events/${eventId}/comments/${commentId}`);
};

export const addEventCommentEvidence = async (eventId, commentId, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('images[]', file));

  const { data } = await axios.post(
    `/schedule/events/${eventId}/comments/${commentId}/evidences`,
    formData
  );

  return data?.data;
};

export const deleteEventCommentEvidence = async (commentId, imageId) => {
  await axios.delete(
    `/schedule/events/comments/${commentId}/evidences/${imageId}`
  );
};

export const createEventAction = async (
  eventId,
  { userId, type, geolocation }
) => {
  const { data } = await axios.post(`/schedule/events/${eventId}/actions`, {
    userId,
    type,
    geolocation,
  });

  return data?.data;
};
